import * as com from 'smartdishpro-scripts/ts_common';

export const Collection = com.Collection;
